import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
    QueryList,
    ViewChildren
} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { BlurFocusedOnWheelDirective, TooltipDirective } from '../../directives';
import { IComponentFactory } from '../../interfaces/component-factory.interface';
import { IEditorItemConfig } from '../../interfaces/editor-item-config.interface';
import { IdGeneratorPipe } from '../../pipes/id-generator.pipe';
import { EditorItemComponent } from '../editor-item/editor-item.component';
import { TooltipPosition } from './../../directives/tooltip.directive';
import { IconSanitizerService } from './../../services/icon-sanitizer.service';

@Component({
    selector: 'lib-generic-card',
    templateUrl: './generic-card.component.html',
    styleUrls: ['./generic-card.component.scss'],
    hostDirectives: [BlurFocusedOnWheelDirective],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, IdGeneratorPipe, EditorItemComponent, TooltipDirective]
})
export class GenericCardComponent {
    @Input()
    factory?: IComponentFactory;

    @Input()
    configItems: IEditorItemConfig[];

    @Input()
    title?: string;

    @Input()
    highlight?: boolean;

    @Input()
    genericCardId?: string;

    @Input()
    hasArchivedItems?: boolean;

    @Output()
    valueChange: EventEmitter<boolean>;

    @ViewChildren('editorItem')
    editors?: QueryList<EditorItemComponent>;

    alertLogo: SafeHtml;

    tooltipPosition: TooltipPosition;

    constructor(private readonly iconSanitizer: IconSanitizerService) {
        this.factory = undefined;
        this.configItems = [];
        this.highlight = false;
        this.valueChange = new EventEmitter<boolean>();
        this.alertLogo = this.iconSanitizer.getIcon('alertLogo');
        this.tooltipPosition = TooltipPosition.ABOVELEFT;
    }

    emitValueChanged(): void {
        this.valueChange.emit();
    }

    validate(): boolean {
        return this.editors?.map((editorItem) => editorItem.validate()).every((editorItem) => editorItem) ?? false;
    }

    clearValidationErrors(): void {
        this.editors?.forEach((editorItem) => editorItem.clearValidationErrors());
    }
}
